import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ContactUs.css";

const ContactUs = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact Us | Protek Consult - Civil Engineering Consultancy</title>
        <meta name="description" content="Contact Protek Consult in Tarnaka, Hyderabad for civil engineering and architecture services. Reach us via phone, email, or visit our office for expert consultations." />
        <meta name="keywords" content="contact Protek Consult, Protek Consult Tarnaka Hyderabad, civil engineering consultants contact, architecture firm contact, Protek Consult phone number, Protek Consult email" />
        <link rel="canonical" href="https://protekconsult.com/contact" />
        <meta property="og:title" content="Contact Us | Protek Consult" />
        <meta property="og:description" content="Get in touch with Protek Consult for any inquiries or support." />
        <meta property="og:url" content="https://protekconsult.com/contact" />
      </Helmet>
    <div className="contact-container">
      <div className="contact-header" data-aos="fade-down">
        <h1>Contact Us</h1>
        <p>Get in touch with us for any inquiries or support</p>
      </div>

      <div className="contact-content">
        <div className="contact-info" data-aos="fade-right">
          <div className="info-item">
            <div className="info-icon">📍</div>
            <div className="info-text">
              <h3>Address</h3>
              <p><a href="https://www.google.com/maps/search/?api=1&query=Door+401,+Pavani+Anasuya+Towers,+Tarnaka,+Hyderabad" target="_blank" rel="noopener noreferrer">Door 401, Pavani Anasuya Towers, Tarnaka, Hyderabad.</a></p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">📧</div>
            <div className="info-text">
              <h3>Email</h3>
              <p><a href="mailto:info@protekconsult.com">info@protekconsult.com</a></p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">📞</div>
            <div className="info-text">
              <h3>Phone</h3>
              <p><a href="tel:9030064343">90300 64343</a> / <a href="tel:9959996069">99599 96069</a></p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">🕒</div>
            <div className="info-text">
              <h3>Working Hours</h3>
              <p>Monday - Saturday: 9:00 AM - 7:00 PM</p>
            </div>
          </div>
        </div>

        <div className="contact-form" data-aos="fade-left">
          <h2>Send us a Message</h2>
          <img 
            src={process.env.PUBLIC_URL + '/Assets/contactus.png'} 
            alt="Contact illustration" 
            style={{ width: '160%', maxWidth: '500px', marginBottom: '20px', borderRadius: '8px' , height: '340px'  }}
          />
          <button
            type="button"
            className="submit-btn"
            onClick={() => window.open("https://forms.gle/nMjCtXUQw56SuSAQ7", "_blank")}
          >
            Send Message
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default ContactUs;
